import React from 'react';
import './Taskbar.css';

const Taskbar = ({ windows, onWindowClick, onStartClick, onTaskManagerClick }) => {
  const [currentTime, setCurrentTime] = React.useState(new Date());
  const [isMuted, setIsMuted] = React.useState(false);
  const [languageMenu, setLanguageMenu] = React.useState(false);
  const [selectedLanguage, setSelectedLanguage] = React.useState('EN');

  const languages = [
    { code: 'EN', label: 'English' },
    { code: 'TR', label: 'Türkçe' },
    { code: 'ES', label: 'Español' },
    { code: 'FR', label: 'Français' },
    { code: 'DE', label: 'Deutsch' },
    { code: 'IT', label: 'Italiano' },
    { code: 'RU', label: 'Русский' },
    { code: 'JA', label: '日本語' },
  ];

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  React.useEffect(() => {
    if (languageMenu) {
      const handleClickOutside = () => setLanguageMenu(false);
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [languageMenu]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  const toggleLanguageMenu = (e) => {
    e.stopPropagation();
    setLanguageMenu(!languageMenu);
  };

  const selectLanguage = (langCode) => {
    setSelectedLanguage(langCode);
    setLanguageMenu(false);
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const formatDate = (date) => {
    // Always show 1998 for retro Windows 3.1 feel
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    return `${month} ${day}, 1998`;
  };

  return (
    <div className="taskbar">
      <button className="start-button" onClick={onStartClick}>
        <span className="start-icon">
          <img src="/assets/icons/windows-logo.png" alt="Windows" />
        </span>
        <span className="start-text">Start</span>
      </button>

      <button className="task-manager-button" onClick={onTaskManagerClick} title="Task Manager">
        <img src="/assets/icons/task-manager.png" alt="Task Manager" />
        <span className="task-manager-text">Task Manager</span>
      </button>

      <div className="taskbar-windows">
        {windows.map((window) => (
          <button
            key={window.id}
            className="taskbar-window-btn"
            onClick={() => onWindowClick(window.id)}
          >
            {window.icon && (
              <span className="window-icon">
                <img src={window.icon} alt="" />
              </span>
            )}
            <span className="window-title">{window.title}</span>
          </button>
        ))}
      </div>

      <div className="system-tray">
        <div className="system-icons">
          <div className="language-selector">
            <button
              className="system-icon"
              title="Keyboard Layout"
              onClick={toggleLanguageMenu}
            >
              <img src="/assets/icons/keyboard.png" alt="Keyboard" />
              <span className="language-code">{selectedLanguage}</span>
            </button>
            {languageMenu && (
              <div className="language-dropdown">
                {languages.map((lang) => (
                  <div
                    key={lang.code}
                    className={`language-item ${selectedLanguage === lang.code ? 'active' : ''}`}
                    onClick={() => selectLanguage(lang.code)}
                  >
                    <span className="lang-code">{lang.code}</span>
                    <span className="lang-label">{lang.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <button className="system-icon" title="Phone Dialer">
            <img src="/assets/icons/phone-dial.png" alt="Phone Dialer" />
          </button>
          <button
            className="system-icon"
            title={isMuted ? "Unmute" : "Mute"}
            onClick={toggleMute}
          >
            <img
              src="/assets/icons/sound.png"
              alt={isMuted ? "Muted" : "Volume"}
              style={{ opacity: isMuted ? 0.3 : 1 }}
            />
          </button>
        </div>
        <div className="clock">
          <div className="time">{formatTime(currentTime)}</div>
          <div className="date">{formatDate(currentTime)}</div>
        </div>
      </div>
    </div>
  );
};

export default Taskbar;
